export default __webpack_public_path__ + "static/media/mainRoom.c5b06ce8.jpeg";